import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Input,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import filterFactory, {
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import Select from "react-select";
import {
  postSubmitForm,
  postSubmitForm_withformdata,
} from "../../../helpers/forms_helper";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import {
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import EnterQuantityModal from "../../../components/EnterQuantityModal";
import UpdateQuantityModal from "../../../components/UpdateQuantityModal";
import calculatePrice from "../../../helpers/calculate_price";
import ReplaceItemModal from "../ReplaceItemModal";
import ConfirmationDialogue from "../../../components/ConfirmationDialogue";
import { CheckExpiryDateValidation } from "../../../helpers/po_helper";
import ReceiveConfirmationDialog from "../../../components/ReceiveConfirmationDialog";

const ViewPO = (props) => {
  const [POItems, setPOItems] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const role = localStorage.getItem("role");
  const [freeGoodsModal, setFreeGoodsModal] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [closePO, setClosePO] = useState();
  const [replaceItemModal, setReplaceItemModal] = useState(false);
  const [allMappedItems, setAllMappedItems] = useState([]);
  const [selectedItemForReplacement, setSelectedItemForReplacement] =
    useState(null);
  const loadMappedItems = async (store) => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
      const response = await postSubmitForm(url, { store_id: store._id });
      if (response && response.status === 1) {
        // let filteredItem = store.type === "CENTRAL STORE" ?  response.data : response.data.filter((d)=>d.is_po_allowed===true)
        let filteredItem = response?.data.filter((d) => d.is_active) || [];
        const selectOptions = filteredItem.map((item) => ({
          _id: item.item_id,
          name: item.name,
          unit_levels: item.unit_levels,
          available: item.available,
          unit_for_po: item.unit_for_po,
          is_po_allowed: item.is_po_allowed,
          po_price: Number(item.po_price),
          store_available: item.store_available,
          threshold: item.threshold,
          unit_for_threshold: item.unit_for_threshold,
          category: item.category,
          sub_category: item.sub_category,
          max_order_limit: item.max_order_limit,
          unit_for_max_order: item.unit_for_max_order,
          is_premium_item: item.is_premium_item,
          label: item.name,
          value: item.item_id,
        }));
        setAllMappedItems(selectOptions);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      preloader(false);
    }
  };
  const { SearchBar } = Search;

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  const [filteredPO, setFilteredPO] = useState([]);
  function afterFilter(newResult, newFilters) {
    setFilteredPO((prevOrders) => {
      return JSON.stringify(prevOrders) !== JSON.stringify(newResult)
        ? newResult
        : prevOrders;
    });
  }
  const [allPO, setAllPO] = useState([]);
  const loadAllPO = async () => {
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");

      if (daysDiff > 31) {
        setAllPO([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllPO([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/getall";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
      });

      if (!response || response.status !== 1) {
        showNotification((response && response.message) || "Error", "Error");
        return false;
      }

      const allData = response.data || [];
      if (allData.length <= 0) {
        showNotification("No Orders data found", "error");
        setAllPO([]);
        return false;
      }
      const updatedData = allData.map((po) => {
        return {
          ...po,
          items: (po.items || []).map((item) => {
            return {
              ...item,
              old_price: item.price,
              receive: item.receive?.map((obj, index) => ({
                index,
                unit: obj.unit,
                value: obj.value,
                isChecked: true,
              })),
            };
          }),
        };
      });
      setAllPO(updatedData);
    } catch (error) {
      console.log(error);
      return false;
    } finally {
      preloader(false);
    }
  };

  const [allReplacemnets, setAllReplacemnets] = useState([]);
  const loadAllReplacements = async (po_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + "purchaseorders/replacement_details";
      const response1 = await postSubmitForm(url, { po_id: po_id });
      if (response1 && response1.status === 1) {
        preloader(false);
        setAllReplacemnets(response1.data);
      } else {
        preloader(false);
        return false;
        // showNotification(response1.message, "Error");
      }
    } catch (error) {
      return false;
      // showNotification(error)
    } finally {
      preloader(false);
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadAllItems = async () => {
    if (allItems.length > 0) return;
    let url = process.env.REACT_APP_BASEURL + "items/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let filtered = response.data?.filter((d) => d.is_active) || [];
      setAllItems(filtered);
    } else {
      showNotification(response.message, "Error");
      return false;
    }
  };

  const sendEmail = async (id) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "purchaseorders/email_by_id";
    const response = await postSubmitForm(url, { id: id });

    if (response && response.status === 1) {
      preloader(false);
      showNotification("Email sent successfully", "Success");
    } else {
      preloader(false);
      showNotification(response.message, "Error");
      return false;
    }
  };

  const [confirmResendNewPO, setConfirmResendNewPO] = useState(false);
  const resendNewPo = async () => {
    try {
      if (selectedPO.items?.length <= 0) return;
      const itemsForPO = selectedPO.items
        .filter((item) => item.receive.some((unit) => unit.value != 0))
        .map((item) => {
          return {
            item_id: item.item_id,
            name: item.name,
            brand: item.brand,
            category: item.category,
            price: +item.price,
            unit_for_po: item.unit_for_po,
            total_price: calculatePrice(
              item.unit_levels,
              item.receive,
              item.price,
              item.unit_for_po,
            ),
            sub_category: item.sub_category,
            quantity: item.receive.map(({ unit, value }) => ({ unit, value })),
            unit_levels: item.unit_levels.map(({ unit, value }) => ({
              unit,
              value,
            })),
          };
        });
      let payload = {
        id: selectedPO._id,
        supplier: selectedPO.supplier,
        branch_details: selectedPO.branch_details,
        item_details: itemsForPO,
        item_total_price: itemsForPO.reduce(
          (acc, curr) => acc + curr.total_price,
          0,
        ),
      };
      switch (selectedPO.branch_details.type) {
        case "CENTRAL STORE":
          Object.assign(payload, {
            deliver_at_branch: false,
          });
          break;
        case "CENTRAL KITCHEN STORE":
          Object.assign(payload, {
            deliver_at_branch: selectedPO.deliver_at_branch,
          });
          break;
        case "Branch":
          Object.assign(payload, {
            deliver_at_branch: selectedPO.deliver_at_branch,
          });
          break;
        case "Sub Store":
          Object.assign(payload, {
            deliver_at_substore: selectedPO.deliver_at_substore,
          });
          break;
        case "Main Store":
          Object.assign(payload, {
            deliver_at_mainstore: selectedPO.deliver_at_mainstore,
          });
          break;
      }

      // console.log(payload,"pl"); return
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/insert_partial";
      const response = await postSubmitForm(url, payload);

      if (response && response.status === 1) {
        preloader(false);
        // for (let i = 0; i < response.data.length; i++) {
        window.open(`/purchase_order?po_id=${response.data}`, "_blank");
        // }
        showNotification(
          "New PO generated for remaining items and current PO closed",
          "Success",
        );
        setSelectedPO();
        loadAllPO();
      } else {
        preloader(false);
        showNotification(response.message, "Error");
        return false;
      }
    } catch (error) {
      preloader(false);
      showNotification(error.message, "Error");
      return false;
    }
  };

  const [selectedItem, setSelectedItem] = useState();
  const [receiveModal, setReceiveModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    let isDisabled = row.isFullyReceived;
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {
            // (selectedPO.deliver_at_branch === false && selectedPO.deliver_at_mainstore === false && selectedPO.deliver_at_substore === false) &&
            selectedPO.status !== "Delivered" &&
              selectedPO.status !== "Closed" && (
                <Button
                  className="btn btn-success btn-sm"
                  hidden={!isPoEditable || isDisabled}
                  onClick={() => {
                    let updatedItem = {
                      ...row,
                      quantity: row.receive?.map((item, idx) => ({
                        ...item,
                        index: idx,
                        isChecked: true,
                      })),
                    };
                    setSelectedItem(updatedItem);
                    setSelectedRowsUnit(row.receive);
                    setReceiveModal(!receiveModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
              )
          }
        </div>
      </>
    );
  }

  const [addFreeunitModal, setAddFreeunitModal] = useState(false);
  const [editFreeunitModal, setEditFreeunitModal] = useState(false);
  const [freeGoods, setFreeGoods] = useState([]);
  function EditUnits(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.receive && row.receive)}
          </span>
          {
            // (selectedPO.deliver_at_branch === false && selectedPO.deliver_at_mainstore === false && selectedPO.deliver_at_substore === false) &&
            selectedPO.status !== "Delivered" &&
              selectedPO.status !== "Closed" && (
                <>
                  {row.receive && row.receive?.length > 0 ? (
                    <Button
                      className="btn btn-success btn-sm"
                      onClick={() => {
                        let updatedItem = {
                          ...row,
                          quantity: row.receive?.map((item, idx) => ({
                            ...item,
                            index: idx,
                            isChecked: true,
                          })),
                        };
                        setSelectedItem(updatedItem);
                        setEditFreeunitModal(true);
                      }}
                    >
                      <i class="mdi mdi-edit"></i>
                      {props.t("Edit")}
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-success\ btn-sm"
                      onClick={() => {
                        setSelectedItem(row);
                        setAddFreeunitModal(!addFreeunitModal);
                      }}
                    >
                      <i class="mdi mdi-edit"></i>
                      {props.t("Add")}
                    </Button>
                  )}
                </>
              )
          }
        </div>
      </>
    );
  }

  const [itemsModal, setItemsModal] = useState();
  const [selectedPO, setSelectedPO] = useState();
  const oneYearFromNow = moment().add(1, "year").format("YYYY-MM-DD");

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const handleToggle = (rowIndex) => {
    setDropdownOpen((prevState) => (prevState === rowIndex ? null : rowIndex));
  };

  function handleSetItemsToReceive(row) {
    let arr = JSON.parse(JSON.stringify(row.items));

    const {
      temporary_delivery_details,
      deliver_at_branch,
      deliver_at_mainstore,
      deliver_at_substore,
    } = row || {};
    const isDeliveredAtStore =
      (deliver_at_branch || deliver_at_mainstore || deliver_at_substore) ??
      false;
    const hasTemporaryDetails = Boolean(temporary_delivery_details?.length);
    //  console.log(isDeliveredAtStore,"isDeliveredAtStore");
    //  console.log(hasTemporaryDetails,"hasTemporaryDetails");
    if (isDeliveredAtStore && hasTemporaryDetails) {
      const freeItems = [];
      setInvoiceNumber(row?.temporary_delivery_details[0]?.invoice_number);

      arr.forEach((obj) => {
        const deliveredItem = row.temporary_delivery_details?.find(
          (delivery) =>
            delivery.item_id === obj.item_id && delivery.free !== true,
        );

        if (deliveredItem) {
          obj.receive = deliveredItem.receive || [];
          obj.old_price = deliveredItem.old_price || 0;
          obj.price = deliveredItem.price || 0;
          obj.isFullyReceived = false;
          obj.expiry_date = deliveredItem?.expiry_date ?? oneYearFromNow;
        }
      });

      if (Array.isArray(row.temporary_delivery_details)) {
        row.temporary_delivery_details.forEach((deliveredItem) => {
          if (deliveredItem?.free === true) {
            freeItems.push({
              ...deliveredItem,
              label: deliveredItem.name,
              value: deliveredItem.item_id,
              free: "yes",
              expiry_date: deliveredItem?.expiry_date ?? oneYearFromNow,
            });
          }
        });
      }
      setFreeGoods(freeItems);
    } else {
      // console.log('non-temp');
      setInvoiceNumber("");
      arr.forEach((obj) => {
        obj.isFullyReceived = Array.isArray(obj.receive)
          ? obj.receive.every(({ value }) => value == 0 || value === "")
          : false;
        obj.expiry_date = oneYearFromNow;
      });
    }

    setPOItems(arr);
    setInvoice();
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const {
    status,
    temporary_delivery_details,
    deliver_at_branch,
    deliver_at_mainstore,
    deliver_at_substore,
  } = selectedPO || {};

  const isDeliveredAtStore =
    (deliver_at_branch || deliver_at_mainstore || deliver_at_substore) ?? false;
  const hasTemporaryDetails = Boolean(temporary_delivery_details?.length);

  const isPoEditable =
    ["Pending", "Received", "Partially Delivered"].includes(status) &&
    (!isDeliveredAtStore || hasTemporaryDetails);
  // console.log(isDeliveredAtStore,"isDeliveredAtStore");
  // console.log(hasTemporaryDetails,"hasTemporaryDetails");
  // console.log(isPoEditable,"isPoEditable");

  function editFormatter(cell, row, rowIndex) {
    const hasTemporary = Boolean(row?.temporary_delivery_details?.length);
    return (
      <div
        className="text-center dropdown-container"
        onClick={() => {
          handleToggle(rowIndex);
        }}
      >
        <Dropdown
          isOpen={dropdownOpen === rowIndex}
          toggle={() => console.log("")}
          direction="left"
          style={{ zIndex: 1 }}
        >
          <DropdownToggle
            tag="i"
            className="mdi mdi-dots-vertical font-size-20"
            style={{ cursor: "pointer" }}
          />
          {dropdownOpen === rowIndex && (
            <DropdownMenu onClick={(e) => e.stopPropagation()}>
              <DropdownItem
                onClick={() => {
                  setSelectedPO(row);
                  loadMappedItems(row.branch_details);
                  loadAllReplacements(row.po_id);
                  setAllReplacemnets([]);
                  handleSetItemsToReceive(row);
                  setItemsModal(!itemsModal);
                  setDropdownOpen(null);
                }}
                style={{ padding: "5px 10px 0px 10px " }}
              >
                <i className="mdi mdi-text-box-search mr-2"></i>
                View Details
              </DropdownItem>
              <DropdownItem
                href={"/purchase_order?po_id=" + row._id}
                target="_blank"
                onClick={() => setDropdownOpen(null)}
                style={{ padding: "5px 10px 0px 10px " }}
              >
                <i className="mdi mdi-printer mr-2"></i>
                Print PO
              </DropdownItem>
              {role !== "Central Store Assistant" &&
                role !== "Storekeeper" &&
                row.status != "Pending Approval" &&
                row.status != "Rejected" &&
                row.status != "Closed" && (
                  <DropdownItem
                    onClick={() => {
                      sendEmail(row._id);
                      setDropdownOpen(null);
                    }}
                    style={{ padding: "5px 10px 0px 10px " }}
                  >
                    <i className="bx bx-mail-send mr-2"></i>
                    Send Email
                  </DropdownItem>
                )}
              {role !== "Central Store Assistant" &&
                role !== "Storekeeper" &&
                row.status === "Partially Delivered" &&
                !hasTemporary && (
                  <DropdownItem
                    onClick={() => {
                      setSelectedPO(row);
                      setConfirmResendNewPO(true);
                      setDropdownOpen(null);
                    }}
                    style={{ padding: "5px 20px 0px 10px " }}
                  >
                    <i className="mdi mdi-text-box-plus-outline mr-2"></i>
                    {/* Generate New PO for remaining items */}
                    Create Remaining PO
                  </DropdownItem>
                )}
              {row?.status !== "Closed" && (
                <DropdownItem
                  onClick={() => {
                    // setClosePO(row);
                    setSelectedPO(row);
                    setConfirmClose(true);
                    setDropdownOpen(null);
                    handleSetItemsToReceive(row);
                  }}
                  style={{ padding: "5px 10px 0px 10px " }}
                >
                  <i className="mdi mdi-close mr-2"></i>
                  Close
                </DropdownItem>
              )}
            </DropdownMenu>
          )}
        </Dropdown>
      </div>
    );
  }

  const getLocation = (row) => {
    switch (true) {
      case row.deliver_at_branch === true:
        return row.branch_details?.type || "Branch";

      case row.deliver_at_substore === true:
        return "Sub Store";

      case row.deliver_at_mainstore === true:
        return "Main Store";

      default:
        return "Central Store";
    }
  };
  const pagination_options = {
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    showTotal: true,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
  };
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      text: props.t("#"),
      headerStyle: () => ({ width: "4%" }),
    },
    {
      text: props.t("PO ID"),
      dataField: "po_id",
      sort: true,
      headerStyle: () => ({ width: "8%" }),
    },
    {
      text: props.t("Store Name"),
      dataField: "branch_details.name",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ branch_details: value }) => ({
                    value: value.name,
                    label: value.name,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
        placeholder: "All",
        // defaultValue: (tableFilters["branch_details.name"] && (tableFilters["branch_details.name"].filterVal || tableFilters["branch_details.name"].value)) || "",
      }),
    },
    {
      text: props.t("Supplier Info"),
      dataField: "supplier.name",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      formatter: (cell, row) => (
        <div>
          <div>{row.supplier?.name}</div>
          <small className="text-muted">
            <i className="mdi mdi-phone mr-1"></i>
            {row.supplier?.mobile}
          </small>
        </div>
      ),
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ supplier: value }) => ({
                    value: value?.name,
                    label: value?.name,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
        placeholder: "All",
        // defaultValue: (tableFilters["supplier.name"] && (tableFilters["supplier.name"].filterVal || tableFilters["supplier.name"].value)) || "",
      }),
    },
    {
      text: props.t("Deliver at Store/Branch"),
      sort: true,
      headerStyle: () => ({ width: "8%" }),
      formatter: (cell, row) => {
        switch (row.branch_details?.type) {
          case "Branch":
            return row.deliver_at_branch ? "Yes" : "No";
          case "Main Store":
            return row.deliver_at_mainstore ? "Yes" : "No";
          case "Sub Store":
            return row.deliver_at_substore ? "Yes" : "No";
          case "CENTRAL KITCHEN STORE":
            return row.deliver_at_branch ? "Yes" : "No";
          default:
            return "";
        }
      },
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm"),
      sort: true,
      headerStyle: () => ({ width: "10%" }),
    },
    {
      dataField: "invoice_fields",
      text: "Invoices",
      formatter: (cell) => (Array.isArray(cell) ? cell.join(", ") : cell),
      filter: textFilter({
        placeholder: "Search...",
        style: {
          maxWidth: "120px",
          height: "30px",
          padding: "4px 6px",
        },
      }),
      sort: false,
      headerStyle: () => ({ width: "10%" }),
    },
    {
      dataField: "status",
      text: props.t("Status & Details"),
      sort: true,
      headerStyle: () => ({ width: "13%" }),
      formatter: (cell, row) => {
        let receivedBy = "";
        if (row?.received_by) {
          receivedBy = row.received_by;
        }

        let time = "";
        if (row?.receiving_date) {
          time = row.receiving_date;
        }
        let receivedFrom = getLocation(row) || "";
        return (
          <div>
            <div className={`badge badge-${getStatusBadgeColor(cell)}`}>
              {cell}
            </div>
            {row.status === "Closed" && (
              <div className="mt-1 small">
                {row.closing_remark && (
                  <div className="text-muted">
                    <i className="mdi mdi-comment-text-outline mr-1"></i>
                    {row.closing_remark}
                  </div>
                )}
                {row.manual_closed_by && (
                  <div className="text-muted">
                    <i className="mdi mdi-account mr-1"></i>
                    Manually closed by - {row.manual_closed_by}
                  </div>
                )}
              </div>
            )}
            {row.status !== "Pending" && receivedBy && (
              <div className="text-muted small">
                <i className="mdi mdi-account-check mr-1"></i>
                Received by: {receivedFrom} - {receivedBy}
                {time && " " + moment(time).format("YYYY-MM-DD HH:mm")}
              </div>
            )}
          </div>
        );
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ status: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
        placeholder: "All",
        // defaultValue: (tableFilters["status"] && (tableFilters["status"].filterVal || tableFilters["status"].value)) || "",
      }),
    },
    {
      text: props.t("Action"),
      dataField: "",
      formatter: (cell, row, rowIndex) => {
        return editFormatter(cell, row, rowIndex);
      },
      formatExtraData: dropdownOpen,
      sort: false,
      headerStyle: () => ({ width: "5%" }),
    },
  ];

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
      case "Pending Approval":
        return "warning";
      case "Partially Delivered":
        return "info";
      case "Closed":
        return "secondary";
      default:
        return "primary";
    }
  };

  const columns_replaced_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Old Item"),
      dataField: "old_item_details",
      formatter: (cell, row) => {
        let old_item = row.old_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              {/* <Col lg={3} md={3} sm={3}><strong>Formula</strong></Col>
            <Col lg={9} md={9} sm={9}>: &nbsp;&nbsp; {mapUnits(old_item?.unit_levels)}</Col> */}
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
    {
      text: props.t("Updated Item"),
      dataField: "new_item_details",
      formatter: (cell, row) => {
        let old_item = row.new_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Remarks</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.remarks}
              </Col>
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
  ];

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    // {
    //   dataField: "sub_category",
    //   text: props.t("Sub-Category"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    //   editable: false,
    // },

    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.old_price + "/" + row.unit_for_po;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      editable: false,
    },
    {
      dataField: "price",
      text: props.t("New Price"),
      editable: (cell, row) => {
        return !row.isFullyReceived;
      },
      hidden: selectedPO?.status === "Closed",
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_po;
      },
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        if (!isPoEditable) return { cursor: "default" };
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: isPoEditable ? props.t("Received") : props.t("To Receive"),
      editable: false,
      formatter: ReceiveFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        // if(!isPoEditable) return { cursor: "default" };
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      hidden: selectedPO?.status === "Closed",
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        let isDisabled = row.isFullyReceived;
        if (!isPoEditable) return { cursor: "default" };
        if (selectedPO?.status === "Closed" || isDisabled) {
          return { cursor: "default" };
        }
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "",
      text: props.t("Replace"),
      sort: false,
      editable: false,
      hidden: selectedPO?.status === "Closed" || !isPoEditable,
      formatter: (cell, row) => {
        let isDisabled = row.isFullyReceived;
        return (
          <>
            {
              //  (selectedPO.deliver_at_branch === false && selectedPO.deliver_at_mainstore === false && selectedPO.deliver_at_substore === false) &&
              selectedPO.status !== "Delivered" &&
                selectedPO.status !== "Closed" && (
                  <span className="d-flex justify-content-between">
                    <i
                      hidden={isDisabled}
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#",
                      }}
                      title="Clik to replace Item"
                      className="mdi mdi-swap-horizontal info"
                      onClick={() => {
                        setSelectedItemForReplacement(row);
                        setReplaceItemModal(true);
                      }}
                    />
                  </span>
                )
            }
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const columns_free_goods = [
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("To Receive"),
      editable: false,
      formatter: EditUnits,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: true,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      editor: {
        type: Type.DATE,
      },
      validator: (newValue, row) => {
        const today = moment().startOf("day");

        if (!newValue) {
          return {
            valid: false,
            message: "Expiry date is required.",
          };
        }

        if (!moment(newValue).isValid()) {
          return {
            valid: false,
            message: "Please enter a valid date.",
          };
        }

        if (moment(newValue).isBefore(today)) {
          return {
            valid: false,
            message: "Expiry date cannot be in the past.",
          };
        }

        return true;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price ? row.price + "/" + row.unit_for_po : 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      dataField: "free",
      text: props.t("Free"),
      formatter: (cell, row) => {
        return row.free ? "YES" : "NO";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("Received"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.receive);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Receiving Date"),
      editable: false,
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },

      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "expiry_date",
      text: "Expiry",
      editable: false,
      formatter: (cell, row) => {
        let dateObj = cell;
        if (typeof cell !== "object") {
          dateObj = new Date(cell);
        }
        return row.expiry_date;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "invoice_number",
      text: props.t("Invoice"),
      editable: false,
      formatter: (cell, row) => {
        if (row.invoice_url) {
          return (
            <a href={row.invoice_url}>
              <i
                className="mdi mdi-download font-size-15"
                title="Download Invoice"
              ></i>
            </a>
          );
        } else {
          return row.invoice_number;
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
  ];

  const [isDisabled, setIsDisabled] = useState(false);
  const [showReceiveConfirm, setShowReceiveConfirm] = useState(false);

  const handleReceiveItems = async (e) => {
    e.preventDefault();

    const expiryValidation = CheckExpiryDateValidation(
      POItems,
      freeGoods || [],
    );
    if (!expiryValidation.isValid) {
      showNotification(expiryValidation.message, "Warning");
      return;
    }
    setShowReceiveConfirm(true);
  };

  const processReceiveItems = async (data) => {
    try {
      //  setItemsModal(!itemsModal);
      //   setFreeGoods([]);
      //   showNotification("Purchase Order Received Successfuly", "Success");
      //   return
      let updatedPOItems;
      if (data.freeGoods && data.freeGoods.length > 0) {
        updatedPOItems = data.POItems.concat(data.freeGoods);
      } else {
        updatedPOItems = data.POItems;
      }

      let item_to_send = updatedPOItems
        .filter((obj) => obj.receive?.some(({ value }) => value != 0))
        .map((item) => ({
          item_id: item.item_id,
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          brand: item.brand,
          unit_for_po: item.unit_for_po,
          price: +item.price,
          free: item.free == "yes" ? true : false,
          total_price:
            item.free != "yes"
              ? calculatePrice(
                  item.unit_levels,
                  item.receive,
                  item.price,
                  item.unit_for_po,
                )
              : 0,
          _id: item._id,
          unit_levels: item.unit_levels.map(({ unit, value }) => ({
            unit,
            value,
          })),
          quantity: item.quantity?.length > 0 ? item.quantity : [],
          expiry_date: item.expiry_date,
          receive: item.receive.map((receiveItem) => ({
            unit: receiveItem.unit,
            value: Number(receiveItem.value),
          })),
        }));

      let formData = new FormData();
      formData.set("id", selectedPO._id);
      formData.set("delivery_details", JSON.stringify(item_to_send));
      formData.append("invoice_number", data.invoiceNumber);
      formData.append("invoice", data.invoice);
      // console.log(item_to_send,"item_to_send");

      setIsDisabled(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/receive";
      const response = await postSubmitForm_withformdata(url, formData);

      if (response && response.status === 1) {
        setIsDisabled(false);
        loadAllPO();
        setItemsModal(!itemsModal);
        setFreeGoods([]);
        showNotification(response.message, "Success");
      } else {
        setIsDisabled(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false);
      showNotification("Error processing request", "Error");
    }
  };

  const handleClosePO = async (remarks) => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/close";
      const response = await postSubmitForm(url, {
        id: selectedPO._id,
        closing_remark: remarks,
      });
      if (response && response.status === 1) {
        setItemsModal(false);
        setConfirmClose(false);
        setClosePO();
        setSelectedPO();
        loadAllPO(response.data);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [invoiceNumber, setInvoiceNumber] = useState();
  const [invoice, setInvoice] = useState();
  const handleDownload = async () => {
    const fileName = "all_po";
    const exportType = "xls";

    let data_to_export = allPO;

    if (data_to_export && data_to_export.length > 0) {
      const data = data_to_export.map((v) => {
        const receivedBy =
          // v?.temporary_delivery_details?.[0]?.received_by ||
          v?.received_by || "";

        const receivingDate =
          // v?.temporary_delivery_details?.[0]?.receiving_date ||
          // v?.delivery_details?.[0]?.receiving_date ||
          v?.receiving_date || "";

        return {
          po_id: v.po_id,
          branch_name: v?.branch_details?.name || "",
          category: v?.category || "",
          supplier_name: v?.supplier?.name || "",
          supplier_mobile: v?.supplier?.mobile || "",
          createdAt:
            (v?.createdAt && moment(v.createdAt).format("YYYY-MM-DD HH:mm")) ||
            "",
          status: v?.status || "",
          Closing_Remark: v?.closing_remark || "",
          Received_By: receivedBy,
          Receiving_Date:
            receivingDate && moment(receivingDate).format("YYYY-MM-DD HH:mm"),
          Manual_Closed_By: v?.manual_closed_by || "",
        };
      });

      exportFromJSON({ data, fileName, exportType });
    } else {
      console.warn("No data available to export");
    }
  };

  const handleSubmit = (quantity) => {
    // event.preventDefault();
    // let checkedUnits = selectedRowsUnit.filter((obj)=>obj.isChecked===true)
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    setReceiveModal(!receiveModal);
    const updatedItems = POItems.map((item) => {
      if (item._id === selectedItem._id) {
        // return selectedItem;
        return { ...item, receive: convertedQuantity };
      }
      return item;
    });
    setSelectedRowsUnit([]);
    setSelectedItem();
    setPOItems(updatedItems);
  };

  const handlAddFreeGoods = () => {
    const isValid = freeGoods.every(
      (item) => item.receive && item.receive.every((row) => row.value == 0),
    );
    if (isValid) {
      showNotification("Enter valid quantity for each item", "Warning");
      return;
    }
    // const updatedPOItems = POItems.concat(freeGoods);
    // setPOItems(updatedPOItems)
    setFreeGoodsModal(!freeGoodsModal);
  };

  const handleSelectItems = (data, changedValue) => {
    // select logic
    if (changedValue.action === "select-option") {
      const modifiedData = data.map((item) => {
        return {
          item_id: item._id,
          _id: item._id,
          label: item.label,
          value: item.value,
          name: item.name,
          category: item.category,
          sub_category: item.sub_category,
          brand: item.brand,
          free: item.free && item.free,
          receive: item.receive && item.receive,
          unit_for_po: item.unit_for_po,
          price: 0,
          total_price: 0,
          expiry_date: oneYearFromNow,
          unit_levels: item.unit_levels,
        };
      });
      setFreeGoods(modifiedData);
    }
    if (changedValue.action === "remove-value") {
      let UpdatedSelectedItem = freeGoods?.filter(
        (item) => item.label !== changedValue.removedValue.label,
      );
      setFreeGoods(UpdatedSelectedItem);
    }
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  // for free goods
  const handleAddUnits = (quantity) => {
    // console.log(quantity,"from free");
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const updatedCartItems = freeGoods.map((item) => {
      if (item._id === selectedItem._id) {
        // return { ...item, receive: selectedRowsUnit.map(row => ({ unit: row.unit, value: row.value })), free: "yes" };
        return { ...item, receive: convertedQuantity, free: "yes" };
      } else {
        return item;
      }
    });
    setFreeGoods(updatedCartItems);
    setSelectedItem([]);
    setSelectedRowsUnit([]);
    setAddFreeunitModal(false);
  };

  const handleUpdateUnit = (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem?.unit_levels,
    );
    const isItemInCart = freeGoods.some(
      (item) => item.item_id === selectedItem.item_id,
    );
    if (isItemInCart) {
      const updatedCartItems = freeGoods.map((item) =>
        item.item_id === selectedItem.item_id
          ? {
              ...item,
              receive: convertedQuantity,
            }
          : item,
      );
      setFreeGoods(updatedCartItems);
      setEditFreeunitModal(false);
    } else {
      const newItem = {
        ...selectedItem,
        receive: convertedQuantity,
      };
      setFreeGoods((prevCartItems) => [...prevCartItems, newItem]);
      setEditFreeunitModal(false);
    }
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_email_sent) {
      style.backgroundColor = "#b0ff9e";
    }
    return style;
  };

  const [isReplacing, setIsReplacing] = useState(false);
  const handleItemReplace = async (replacementData) => {
    try {
      setIsReplacing(true);
      let payload = {
        purchase_order_id: selectedPO._id,
        old_item_id: replacementData.originalItem.item_id,
        new_item_details: replacementData.replacementItem,
        remark: replacementData.replacementItem.remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/replace_item";
      const response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        let data = POItems?.filter(
          (dat) => replacementData.originalItem.item_id !== dat.item_id,
        );
        setPOItems([...data, replacementData.replacementItem]);
        loadAllReplacements(selectedPO.po_id);
        showNotification(response.message, "Success");
        setReplaceItemModal(false);
        return true;
      } else {
        showNotification(response.message, "error");
        return true;
      }
    } catch (error) {
      showNotification(error, "error");
      return true;
    } finally {
      setIsReplacing(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Requisition")}
            alternateTitle={props.t("Purchase Orders")}
            breadcrumbItem1={props.t("All Purchase Orders")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3} md={3} sm={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3} md={3} sm={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3} md={3} sm={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllPO();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      keyField="_id"
                      data={allPO && allPO}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4} className="text-center">
                              <CardTitle>All Purchase Orders</CardTitle>
                            </Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Item
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            keyField={"_id"}
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            filter={filterFactory({ afterFilter })}
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  {/* Item modal */}
                  <Modal
                    size="lg"
                    style={{
                      minWidth: "1200px",
                      maxWidth: "1200px",
                    }}
                    isOpen={itemsModal}
                    onClosed={() => setFreeGoods([])}
                    toggle={() => setItemsModal(!itemsModal)}
                  >
                    <ModalHeader toggle={() => setItemsModal(!itemsModal)}>
                      Purchase Order ID: {selectedPO && selectedPO.po_id}{" "}
                      {/* {selectedPO && selectedPO.status != "Closed" && (
                        <Button
                          type="submit"
                          className="btn-rounded btn btn-danger"
                          onClick={() => {
                            setConfirmClose(true);
                            setClosePO(selectedPO);
                          }}
                        >
                          {props.t("Close")}
                        </Button>
                      )} */}
                    </ModalHeader>
                    <ModalBody>
                      {selectedPO && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <Label>{props.t("Ordered Items")}</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          POItems &&
                                          POItems.filter(
                                            (item) => item.free !== "yes",
                                          )
                                        }
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                    {
                                      // (selectedPO.deliver_at_branch === false && selectedPO.deliver_at_mainstore === false && selectedPO.deliver_at_substore === false) &&
                                      selectedPO.status !== "Delivered" &&
                                        selectedPO.status !== "Closed" && (
                                          <>
                                            <Col lg={12}>
                                              {!isDeliveredAtStore ||
                                              (isDeliveredAtStore &&
                                                hasTemporaryDetails) ? (
                                                <Row>
                                                  <Col lg={12}>
                                                    <AvForm
                                                      onValidSubmit={
                                                        handleReceiveItems
                                                      }
                                                    >
                                                      <Row>
                                                        <Col lg={4}>
                                                          <Label>
                                                            Invoice Number
                                                          </Label>
                                                          <AvField
                                                            type="text"
                                                            name="invoice_number"
                                                            value={
                                                              invoiceNumber
                                                            }
                                                            onChange={(e) =>
                                                              setInvoiceNumber(
                                                                e.target.value,
                                                              )
                                                            }
                                                            placeholder={props.t(
                                                              "Enter invoice no. here...",
                                                            )}
                                                            validate={{
                                                              required: {
                                                                value: true,
                                                                errorMessage:
                                                                  props.t(
                                                                    "Invoice no. is required.",
                                                                  ),
                                                              },
                                                              minLength: {
                                                                value: 3,
                                                                errorMessage:
                                                                  props.t(
                                                                    "must be at least 3 characters.",
                                                                  ),
                                                              },
                                                            }}
                                                          />
                                                        </Col>
                                                        <Col lg={4}>
                                                          <Label>
                                                            Upload Invoice
                                                            Document
                                                          </Label>
                                                          <Input
                                                            type="file"
                                                            id="invoice"
                                                            className="form-control-file"
                                                            onChange={(e) => {
                                                              setInvoice(
                                                                e.target
                                                                  .files[0],
                                                              );
                                                            }}
                                                          />
                                                        </Col>
                                                        <Col
                                                          lg={4}
                                                          className="d-flex align-items-end mb-4"
                                                        >
                                                          <div
                                                            style={{
                                                              position:
                                                                "relative",
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <Button
                                                              type="button"
                                                              color="info"
                                                              className="btn btn-info waves-effect waves-light"
                                                              onClick={() => {
                                                                loadAllItems();
                                                                setFreeGoodsModal(
                                                                  !freeGoodsModal,
                                                                );
                                                              }}
                                                            >
                                                              <i className="bx bx-add-to-queue me-1"></i>
                                                              {props.t(
                                                                "Add Free Goods",
                                                              )}
                                                            </Button>

                                                            {freeGoods?.length >
                                                              0 && (
                                                              <Badge
                                                                pill
                                                                color="danger"
                                                                className="cart-badge"
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  top: "-8px",
                                                                  right: "-8px",
                                                                  fontSize:
                                                                    "0.75rem",
                                                                  minWidth:
                                                                    "20px",
                                                                  height:
                                                                    "20px",
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  justifyContent:
                                                                    "center",
                                                                  zIndex: 1000,
                                                                  border:
                                                                    "2px solid #fff",
                                                                }}
                                                              >
                                                                {
                                                                  freeGoods?.length
                                                                }
                                                              </Badge>
                                                            )}
                                                          </div>
                                                        </Col>

                                                        <Col
                                                          lg={12}
                                                          className="text-center mt-3"
                                                        >
                                                          <Button
                                                            type="submit"
                                                            color="primary"
                                                            style={{
                                                              width: "140px",
                                                            }}
                                                            disabled={
                                                              isDisabled
                                                            }
                                                            className="btn btn-default waves-effect waves-light"
                                                          >
                                                            {isDisabled ? (
                                                              <Spinner size="sm" />
                                                            ) : (
                                                              props.t(
                                                                "Receive Items",
                                                              )
                                                            )}
                                                          </Button>
                                                        </Col>
                                                      </Row>
                                                    </AvForm>
                                                  </Col>
                                                </Row>
                                              ) : (
                                                <Alert
                                                  color="info"
                                                  className="mt-2"
                                                >
                                                  For pending or partially
                                                  delivered POs, the{" "}
                                                  <b>Store/Branch</b> must first
                                                  submit their receiving. Only
                                                  then can you confirm or
                                                  correct the items.
                                                </Alert>
                                              )}

                                              <hr className="mt-2" />
                                            </Col>
                                          </>
                                        )
                                    }
                                  </Row>
                                  {/* Delivered Items  */}
                                  <Row>
                                    <Col lg={12}>
                                      <Label>Delivered Items</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedPO &&
                                          selectedPO.delivery_details
                                        }
                                        columns={columns_delivered_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              // cellEdit={cellEditFactory({
                                              //   mode: "click",
                                              //   blurToSave: true,
                                              // })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>

                                  {/* Replaced Items  */}
                                  {allReplacemnets &&
                                    allReplacemnets?.length > 0 && (
                                      <Row>
                                        <Col lg={12}>
                                          <Label>Replaced Items</Label>
                                          <ToolkitProvider
                                            keyField="old_item_details._id"
                                            data={allReplacemnets}
                                            columns={columns_replaced_items}
                                          >
                                            {(props) => (
                                              <div>
                                                <BootstrapTable
                                                  {...props.baseProps}
                                                  noDataIndication="No data to display."
                                                  striped
                                                  hover
                                                  condensed
                                                />
                                              </div>
                                            )}
                                          </ToolkitProvider>
                                        </Col>
                                      </Row>
                                    )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Confirm Close Modal  */}
                  <ConfirmationDialogue
                    isOpen={confirmClose}
                    title="Close Purchase Order"
                    message="Once you close this purchase order, it cannot be revoked."
                    remarksLabel="Please enter remarks for closing this PO"
                    onConfirm={(remarks) => {
                      handleClosePO(remarks);
                    }}
                    onCancel={() => {
                      setConfirmClose(false);
                    }}
                  />

                  {/* Update Receive Quantity Modal for PO Items*/}

                  <UpdateQuantityModal
                    isOpen={receiveModal}
                    toggle={() => setReceiveModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />

                  {/* --- Add Free Goods Modal Start --- */}
                  <Modal
                    size="lg"
                    isOpen={freeGoodsModal}
                    toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                  >
                    <ModalHeader
                      toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                    >
                      {props.t("Add Free Goods")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={6}>
                          <Label>{props.t("Items")}</Label>
                          <Select
                            options={allItems}
                            value={freeGoods}
                            onChange={(data, changedValue) =>
                              handleSelectItems(data, changedValue)
                            }
                            closeMenuOnSelect={true}
                            classNamePrefix="select"
                            isMulti={true}
                            className="basic-multi-select"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col lg={12}>
                          <Label>{props.t("Free Goods")}</Label>
                          <ToolkitProvider
                            keyField="_id"
                            data={freeGoods || []}
                            columns={columns_free_goods}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  {...props.baseProps}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  noDataIndication="No data to display."
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col lg={12}>
                          <FormGroup className="mb-0 text-center">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-1"
                                onClick={() => handlAddFreeGoods()}
                              >
                                {props.t("Submit")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                  {/* ---Add Free Goods Modal End --- */}

                  {/* --- Replace Item Modal Start --- */}
                  <ReplaceItemModal
                    isOpen={replaceItemModal}
                    toggle={() => setReplaceItemModal(false)}
                    originalItem={selectedItemForReplacement}
                    allItems={allMappedItems}
                    isLoading={isReplacing}
                    onReplace={handleItemReplace}
                  />
                  {/* --- Replace Item Modal End --- */}

                  {/* Add quantity for free goods modal  */}

                  <EnterQuantityModal
                    isOpen={addFreeunitModal}
                    toggle={() => setAddFreeunitModal(false)}
                    onSubmit={handleAddUnits}
                    item={selectedItem}
                  />

                  {/* Update Receive Quantity for free goods Modal  */}

                  <UpdateQuantityModal
                    isOpen={editFreeunitModal}
                    toggle={() => setEditFreeunitModal(false)}
                    onSubmit={handleUpdateUnit}
                    item={selectedItem}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Confirm Resend Po  */}
          {confirmResendNewPO && (
            <SweetAlert
              title={props.t("Are you sure?")}
              warning
              showCancel
              cancelBtnText={props.t("No")}
              confirmBtnText={props.t("Yes")}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => {
                setConfirmResendNewPO(false);
                resendNewPo();
              }}
              onCancel={() => {
                setConfirmResendNewPO(false);
              }}
            >
              {props.t(
                "Once you click a new purchase order will be created for the remaining items, and the current PO will be closed. This action cannot be undone.",
              )}
            </SweetAlert>
          )}

          {/* Confirm Receive  */}
          <ReceiveConfirmationDialog
            isOpen={showReceiveConfirm}
            onConfirm={() => {
              setShowReceiveConfirm(false);
              processReceiveItems({
                POItems,
                freeGoods,
                invoiceNumber,
                invoice,
              });
            }}
            onCancel={() => {
              setShowReceiveConfirm(false);
            }}
            hasFreeGoods={freeGoods?.length > 0}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewPO)),
);
